import * as DropdownMenu from '@radix-ui/react-dropdown-menu'
import tw, { styled } from 'twin.macro'

import { getCombinedStyles } from '../Button/Button.styled'
import { focusStyles } from '../sharedStyles'
import type { ButtonTriggerProps, SizeOptions } from './types'

function getButtonSize(size: SizeOptions) {
  const styleMap = {
    small: tw`
      px-1.5 py-1
      text-xs-brand leading-6`,
    medium: tw`
      px-2 py-2.5
      text-sm-brand`,
    large: tw`
      px-2.5 py-3.5
      text-sm-brand`,
  }

  return styleMap[size]
}

export const DropdownMenuTriggerStyled = styled.button<ButtonTriggerProps>(
  ({ size, palette, variation }) => [
    focusStyles,
    tw`
      border
      border-transparent
      font-brand
      disabled:(opacity-50 cursor-default)
      items-center
      rounded
      rounded-l-none
    `,
    getButtonSize(size),
    getCombinedStyles(palette, variation),
    ['border', 'borderless'].includes(variation) && tw`text-default-muted`,
  ],
)

export const DropdownMenuContentStyled = tw(DropdownMenu.Content)`
  shadow-2xl
  rounded
  mt-2
`

export const DropdownMenuItemStyled = tw(DropdownMenu.Item)`
  bg-default-subdued
  p-5
  rounded
  font-brand
  font-medium
  text-sm-brand
  text-default-neutral
  cursor-pointer
`
